import { Calendar, getCalendarEntryByCalendarId, updateCalendarEntry } from 'owa-calendar-cache';
import {
    findCalendar,
    getCalendars,
    updateStoreCalendars,
} from 'owa-calendar-surface-calendars-store';

import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { findIndexToInsertCalendarAt } from './findIndexToInsertCalendarAt';

export function instantReorderCalendars(
    userIdentity: string,
    draggedCalendarId: string,
    prevCalendarId: string,
    nextCalendarId: string,
    destParentGroupId: string
) {
    if (!prevCalendarId && !nextCalendarId && !destParentGroupId) {
        return;
    }

    const allCalendars: Calendar[] = getCalendars().slice();
    const draggedCalendar = findCalendar(draggedCalendarId);

    // Find and remove the dragged calendar from current position.
    removeDraggedCalendar(draggedCalendarId, allCalendars);

    // If destination group is empty calculate the previous calendarId
    // to determine the index at which the dragged calendar needs to be added.
    if (!prevCalendarId && !nextCalendarId) {
        const index = findIndexToInsertCalendarAt(allCalendars, userIdentity, destParentGroupId);
        allCalendars.splice(index, 0, draggedCalendar);
    } else {
        if (prevCalendarId) {
            insertDraggedCalendar(draggedCalendar, allCalendars, true, prevCalendarId);
        } else {
            insertDraggedCalendar(draggedCalendar, allCalendars, false, nextCalendarId);
        }
    }

    updateStoreCalendars(allCalendars);

    // Update Group Id if the calendar is being moved across groups
    if (destParentGroupId) {
        const draggedCalendarEntry = getCalendarEntryByCalendarId(draggedCalendarId);
        updateCalendarEntry(draggedCalendarEntry?.calendarId.itemId, {
            ParentGroupId: destParentGroupId,
        });
    }
}

function removeDraggedCalendar(calendarId: string, allCalendars: Calendar[]) {
    const findCalendarResult = findInArray(
        allCalendars,
        cal => !!cal.id && cal.id.id == calendarId
    );
    findCalendarResult && allCalendars.splice(findCalendarResult.index, 1);
}

function insertDraggedCalendar(
    draggedCalendar: Calendar,
    allCalendars: Calendar[],
    insertAfter: boolean,
    calendarId: string
) {
    const findResult = findInArray(allCalendars, cal => !!cal.id && cal.id.id == calendarId);

    if (findResult) {
        const index = insertAfter ? findResult.index + 1 : findResult.index;
        allCalendars.splice(index, 0, draggedCalendar);
    }
}
